import { SVG, SVGProps } from './svg'

export function IconToolTriangle(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M17.4 10.4A2 2 0 0016 7a2 2 0 00-1.4 3.4l-6 10.7a2 2 0 101.3 2.4h12.2a2 2 0 101.4-2.4l-6.1-10.7zm5.2 11.2l-6-10.7a2 2 0 01-1.1 0L9.4 21.6c.3.2.4.5.5.9h12.2c0-.4.2-.7.5-1zM17 9a1 1 0 11-2 0 1 1 0 012 0zM8 24a1 1 0 100-2 1 1 0 000 2zm17-1a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </SVG>
  )
}
